export const detalhamentorubrica_indefinida = import.meta.env.VITE_DETALHAMENTO_RUBRICA_INDEFINIDA;
export const detalhamentorubrica_doa = import.meta.env.VITE_DETALHAMENTO_RUBRICA_DOA;
